export const INITIAL_FAILED_RECORDS_STATE: FailedRecordsState = {
  loading: false,
  failureDetails: [],
  error: null,
};

export interface FailedRecordsState {
  loading: boolean;
  failureDetails: any[] | any;
  error: any;
}

export enum RecordsStatus {
  GET_ACTIVATION_RECORDS_FAILURE = 'GET_ACTIVATION_RECORDS_FAILURE',
  SUCCESS_ACTIVATION_RECORDS_FAILURE = 'GET_ACTIVATION_RECORDS_FAILURE_SUCCESS',
  ERROR_ACTIVATION_RECORDS_FAILURE = 'GET_ACTIVATION_RECORDS_FAILURE_ERROR'
}

export const recordsFailureReducer = (state = INITIAL_FAILED_RECORDS_STATE, action) => {
  switch (action.type) {
    case RecordsStatus.GET_ACTIVATION_RECORDS_FAILURE:
      return { ...INITIAL_FAILED_RECORDS_STATE, loading: true };

    case RecordsStatus.SUCCESS_ACTIVATION_RECORDS_FAILURE:
      return {
        ...state,
        failureDetails: action.payload.failureDetails,
        loading: false,
      };

    case RecordsStatus.ERROR_ACTIVATION_RECORDS_FAILURE:
      return { ...INITIAL_FAILED_RECORDS_STATE, error: action.payload.error, loading: false };

    default:
      return state;
  }
};
